export default "__VITE_ASSET__5jDHF9Ek__"